<template>
  <div class="e-page adminAuth">
    <div class="adminAuth__container">
      <h1>Admin</h1>
      <login-form @submit="login" />
      <!-- <e-link class="adminAuth__link" :to="'/admin/signup'"
        >Créer un compte</e-link
      > -->
    </div>
  </div>
</template>

<script>
import LoginForm from '../components/block/login-form'
// import axiosAdmin from "../scripts/axios-admin";

export default {
  name: 'auth',
  components: {
    LoginForm
  },
  methods: {
    login(params) {
      this.$store
        .dispatch('auth/login', params)
        .then(() => {
          this.$store.dispatch('notifications/present', {
            type: 'Notice',
            text: `Vous êtes connecté avec l'email ${params.email}`
          })
          this.$router.push('/admin/configuration')
        })
        .catch(e => {
          this.$store.dispatch('notifications/present', {
            type: 'error',
            text: 'Vérifiez votre email/mot de passe'
          })
          console.warn(e)
        })
    }
  }
}
</script>

<style lang="scss">
.adminAuth {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;

  form {
    margin: var(--spacing-m) 0;

    input {
      margin-top: var(--spacing-l);
    }
  }

  &__container {
    width: 235px;
  }

  &__link {
    display: block;
    margin-top: var(--spacing-l);
  }
}
</style>
